import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles(({ typographyPresets }) => ({
    paymentMethod: {
        display: 'flex',
        justifyContent: 'space-between',
        margin: '10px 0',
    },
    info: {
        display: 'flex',
        alignItems: 'center',
    },
    removeButton: {
        maxWidth: '75px',
    },
    number: {
        ...typographyPresets.bodyTertiaryBold,
        fontWeight: 'bold',
    },
    type: {
        ...typographyPresets.bodyTertiaryLight,
    },
    image: {
        height: '32px',
        marginRight: '10px',
    },
}))
